import { useEffect, useState } from "react";
import {
  getPaymentMethod,
  getEducationalPlatform,
  getProductType,
  getClientFromOrigins,
  SharedDataFromBackend
} from "~/api/apiMethods";
import { TAXONOMY_PAYMENT_METHOD, TAXONOMY_PAYMENT_METHOD_PF2 } from "~/api/apiUrls";

export function useSharedDataFromBackend() {
  const [paymentMethod, setPaymentMethod] = useState<SharedDataFromBackend>();
  const [paymentMethod_PF2, setPaymentMethod_PF2] = useState<SharedDataFromBackend>();
  const [educationalPlatform, setEducationalPlatform] = useState<SharedDataFromBackend>();
  const [productType, setProductType] = useState<SharedDataFromBackend>();
  const [clientFromOrigins, setClientFromOrigins] = useState<SharedDataFromBackend>();

  useEffect(() => {
    getPaymentMethod(TAXONOMY_PAYMENT_METHOD).then(res => {
      setPaymentMethod(res?.data);
    });
    getPaymentMethod(TAXONOMY_PAYMENT_METHOD_PF2).then(res => {
      setPaymentMethod_PF2(res?.data);
    });
    getEducationalPlatform().then(res => {
      setEducationalPlatform(res?.data);
    });
    getProductType().then(res => {
      setProductType(res?.data);
    });
    getClientFromOrigins().then(res => {
      setClientFromOrigins(res?.data);
    });
  }, []);

  return { paymentMethod, paymentMethod_PF2, educationalPlatform, productType, clientFromOrigins };
}
